import { Amount } from "@goodfill/domain-properties/src";
import { formatCurrencyAmount } from "@goodfill/format-number";
import React from "react";

export const BalanceChangeComponent = (props: { value: Amount }) => {
  const formattedValue = formatCurrencyAmount({
    value: props.value.toFixed(2),
    numDecimals: 2,
  });

  const styles: React.CSSProperties = {
    color: props.value.lessThan(0) ? "red" : undefined,
  };

  return <span style={styles}>{formattedValue}</span>;
};
